import { tv } from 'tailwind-variants';

export const container = tv({
  variants: {
    border: {
      base: 'border-gray-150 relative border',
      checked: 'border border-black',
    },
  },
});

export const checkbox = tv({
  base: [
    'action-focus grid h-full w-full appearance-none rounded-full  text-current',
    'before:block before:h-full before:w-full before:scale-0 before:rounded-[inherit] before:bg-current',
    'checked:before:scale-75',
  ],
});

export const label = tv({
  base: 'peer-checked:bg-grey-100 hover:bg-grey-100/10 group flex cursor-pointer items-center transition',
});

export const imageContainer = tv({
  base: 'flex aspect-square w-[100px] flex-shrink-0 items-center justify-center self-stretch bg-beige',
});

export const customCheckbox = tv({
  slots: {
    container: 'ml-4',
    outerCircle:
      'relative flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border border-black',
    innerDot: 'opacity-0 transition group-aria-selected:opacity-100',
  },
});
